import React, { useState, useEffect } from "react";
import "./DotHighlighter.css";

const DotHighlighter = ({
  dotCount,
  value,
  skillsLevelHandler,
  indexArray,
  color,
}) => {
  const [highlightedDots, setHighlightedDots] = useState([]);

  const handleDotHover = (index) => {
    const dotsToHighlight = Array.from({ length: index + 1 }, (_, i) => i);
    setHighlightedDots(dotsToHighlight);
  };

  const cancelhandleDotHover = () => {
    const dotsToHighlight = Array.from({ length: value }, (_, i) => i);
    setHighlightedDots(dotsToHighlight);
  };
  useEffect(() => {
    const dotsToHighlight = Array.from({ length: value }, (_, i) => i);
    setHighlightedDots(dotsToHighlight);
  }, [value]);
  console.log(highlightedDots, "highlightedDots");
  return (
    <div className="dot-container">
      {Array.from({ length: dotCount }, (_, index) => (
        <div
          key={index}
          className={`dot ${
            highlightedDots.includes(index) ? "highlighted" : ""
          }`}
          onMouseEnter={() => handleDotHover(index)}
          onMouseLeave={() => cancelhandleDotHover()}
          onClick={() => skillsLevelHandler(index + 1, indexArray)}
          style={{
            backgroundColor: highlightedDots.includes(index) ? color : "#ccc",
          }}
        ></div>
      ))}
    </div>
  );
};

export default DotHighlighter;
